import React from 'react';
import { Box, Pagination } from '@mui/material';
import PaginationInfo from './PaginationInfo';

const PaginationComponent = ({
  totalCount,
  currentPage,
  perPage,
  handlePageChange,
}) => {
  const totalPages = Math.ceil(totalCount / perPage);

  if (totalPages <= 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        pt: 2,
        pb: 1,
      }}
    >
      <PaginationInfo
        currentPage={currentPage}
        perPage={perPage}
        totalCount={totalCount}
      />

      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(_, page) => handlePageChange(page)}
        size="small"
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
        showFirstButton={totalPages > 5}
        showLastButton={totalPages > 5}
      />
    </Box>
  );
};

export default PaginationComponent;